<ion-button
  class="btn car-button white"
  (click)="carButtonEvent.emit()"
  [color]="isSelected ? 'secondary' : ''"
  [style]="{ '--box-shadow': noShadow ? 'none' : '' }">
  <div class="yf-row gap-12 car-button__content">
    <ion-icon name="car-outline"></ion-icon>
    <ion-text class="car-button__text">
      <h6>{{ name }}</h6>
      <p>{{ model }}</p>
    </ion-text>
  </div>
</ion-button>
